<template>
    <container class="bg">
        <div class="cardList">
          <RepayCard v-for="(item, index) in overdueList" :value="item" class="card" @change="changeCard" :key="index + 'cardList'"/>
        </div>
        <div class="bottomWarp">
            <div class="text1">
                合计：<span class="text2">{{checkedSum}}元</span>
            </div>
            <mu-button class="bottomBtn" color="primary" @click.native="checkApply">
                确定
            </mu-button>
        </div>
    </container>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';
    import RepayCard from './components/repayCard';
    import webApi from '../../request/webapi';
    export default {
        name: "repayList",
        components: {RepayCard},
        data: function(){
          return {
              saber: true,
              overdueList: [],
              // overdueCheck: {},
              checkedSum: 0
          }
        },
        computed: {
            ...mapState({
                // 对公还款 选择
                overdueCheck: (state) => Object.assign({}, state.companyRepayState.overdueCheck) || {},
            })
        },
        async mounted(){
            let data = await webApi.case.repayQueryUserLoanInfo();
            if(data.statusCode == 200){
                this.overdueList = data.result.filter((d) => {
                   if(d.overdueState){
                       // this.overdueCheck[d.coreAccountRequestId] = {
                       //     checked: false,
                       //     periodAmount: d.periodAmount
                       // }
                       let checked = this.overdueCheck[d.coreAccountRequestId] ? this.overdueCheck[d.coreAccountRequestId].checked : true;
                       this.$set(this.overdueCheck, d.coreAccountRequestId, {
                           checked,
                           periodAmount: d.periodAmount
                       })
                        d.checked = checked
                        return d;
                   }
                })
                this.changeCheckedSum()
                console.log(this.overdueList)
            }
        },
        methods: {
            changeCard: function(val) {
                let d = Object.assign({}, this.overdueCheck[val.id], {checked: val.checked})
                this.$set(this.overdueCheck, val.id, d);
                this.changeCheckedSum()
            },
            changeCheckedSum: function(){
                console.log('overdueCheck', this.overdueCheck)
                // this.checkedSum
                let checkedSum = Object.keys(this.overdueCheck).reduce((total, key) => {
                    let num = this.overdueCheck[key].checked ? this.overdueCheck[key].periodAmount * 1000 : 0;
                    console.log('num', num)
                    return total + num;
                }, 0);
                console.log(checkedSum)
                this.checkedSum = checkedSum /1000;
            },
            checkApply: function() {
                this.$store.commit('updateCompanyRepayOverdueCheck', this.overdueCheck);
                this.$store.commit('updateCompanyRepayOverdueCheckedSum', this.checkedSum);
                // this.$router.go(-1);
                this.$emit('change')
            }
        },
        watch: {
            overdueCheck: function () {
                this.changeCheckedSum()
            }
        },
    }
</script>

<style scoped>
.bg{
    display: flex;
    flex-direction: column;
}
.cardList{
    padding: 8px;
    flex: 1;
}
.card{
    margin-bottom: 8px;
}
.bottomWarp{
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
}
.text1{
    font-size: 16px;
    color: #303341;
}
.text2{
   color: #d0021b;
}
.bottomBtn{
    width: 140px;
}
</style>